import React from "react";
import { Box, Divider } from "@wix/design-system";

export const VerticalDivider = () => (
  <Box height="20px">
    <Divider direction="vertical" />
  </Box>
);
